/**
 * Given a trigger and an action, return data in a format that
 * matches the `appletQueryFields` query from the `applet` reducer, allowing us
 * to populate the composer with the contents of the tanda combination.
 */
export default function buildAppletFromTandas(tandas, title, description) {
  const actionFieldValues = JSON.parse(tandas.action.defaults_for_trigger)

  return {
    name: title,
    description,
    published: false,
    archived: false,
    filter_code: null,
    channel_id: tandas.trigger.channel.id.toString(),

    applet_trigger: {
      channel_module_name: tandas.trigger.channel.module_name,
      module_name: tandas.trigger.module_name,

      fields: tandas.trigger.trigger_fields.map(trigger_field => ({
        name: trigger_field.name,
        custom_label: trigger_field.label,
        hidden: trigger_field.hideable,
        default_value_json: JSON.stringify(null),
      })),
    },

    applet_actions: [
      {
        channel_module_name: tandas.action.channel.module_name,
        module_name: tandas.action.module_name,

        fields: tandas.action.action_fields.map(action_field => ({
          name: action_field.name,
          custom_label: action_field.label,
          hidden: action_field.hideable,
          default_value_json: JSON.stringify(
            actionFieldValues[action_field.name]
          ),
        })),
      },
    ],
  }
}
